<template >
  <div class="citySeleter f28" v-if="isShow" @click="isShow=false">
	<div class="wrap">
	  <!--<div class="title">选择地址</div>-->
	  <div class="city-bar f28 ">
		<div class="item oneClamp"
			 :class="currentIndex === 0 ? 'active' : ''"
			 @click.stop="clickTab(0)">{{ currentList[0] ? currentList[0].name : '省'}}</div>
		<div class="item oneClamp"
			 :class="currentIndex === 1 ? 'active' : ''"
			 @click.stop="clickTab(1)">{{ currentList[1] ? currentList[1].name : '市'}}</div>
		<div class="item oneClamp"
			 :class="currentIndex === 2 ? 'active' : ''"
			 @click.stop="clickTab(2)">{{ currentList[2] ? currentList[2].name : '区'}}</div>
	  </div>
	  
	  <div class="city-container">
		<div class="pList" v-if="currentIndex === 0">
		  <li v-for="(item,index) in pList"
			  :key="index"
			  @click.stop="select(item,0)"
			  :class="_getClassName(0,index)">{{item.name}}</li>
		</div>
		<div class="cList" v-if="currentIndex === 1">
		  <li v-for="(item,index) in cList"
			  :key="index"
			  @click.stop="select(item,1)"
			  :class="_getClassName(1,index)">{{item.name}}</li>
		</div>
		<div class="aList" v-if="currentIndex === 2">
		  <li v-for="(item,index) in aList"
			  :key="index"
			  @click.stop="select(item,2)"
			  :class="_getClassName(2,index)">{{item.name}}</li>
		</div>
	  </div>
	  <div class="close" @click.stop="close"></div>
	</div>
  </div>
</template>

<script>
  import addressApi from '@/api/address'
  export default {
    data() {
      return {
        pList:[],
        cList:[],
        aList:[],
        currentIndex:0,
        isShow:false,
        currentList:[]
      }
    },
    created() {
      this._getCityList({parentId:0})
    },
    methods:{
      _getCityList(data) {
        if(this.currentIndex === 0){
          addressApi.getArea(data).then(res=>{
            this.pList = res
          })
        }else if(this.currentIndex === 1){
          addressApi.getArea(data).then(res=>{
            this.cList = res
          })
        }else{
          addressApi.getArea(data).then(res=>{
            if(res.length === 0){
              this.isShow = false
              this.$emit('city-change',this.currentList);
              return
            }
            this.aList = res
          })
        }
      },
	  _getClassName(type,index){
        let list = this.pList, className = ''
		if(type ===1) {
          list = this.cList
		}else if(type === 2) {
          list = this.aList
		}
		if(list.indexOf(this.currentList[0]) === index){
          className = 'on'
		}
		return className
	  },
      select(item,index){
        this.currentList[index] = item;
        // let nIndex = index+1;
        this.currentList.slice(0,index);
        if(this.currentList.length === 3 && index === 2){
          //地址选完整并且选择的是最后一级，出发city-change自定义事件
          this.isShow = false;
          this.$emit('city-change',this.currentList);
          return
        }
        this.currentIndex = index+1;
        this._getCityList({parentId:item.id})
      },
      clickTab(index) {
        
        const length = this.currentList.length;
        // if( this.currentIndex === index ) return
        if( index + 1 > length) return;
        this.currentIndex = index
      },
      show() {
        this.isShow = true
      },
      close() {
        this.isShow = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .citySeleter{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0,0,0,.4);
	z-index: 501;
	.wrap{
	  width: 100%;
	  height: 720px;
	  position: absolute;
	  bottom: 0;
	  left:0;
	  background: $white-color;
	  .title{
		width: 100%;
		text-align: center;
		line-height: 90px;
		font-size: 36px;
	  }
	  .city-bar{
		height: 84px;
		padding: 6px 32px 0;
		box-shadow: $base-shadow;
		line-height: 72px;
		display: flex;
		overflow: hidden;
		.item{
		  max-width: 140px;
		  padding:0 10px;
		  text-align: center;
		  border-bottom: 4px solid transparent;
		  margin-right: 30px;
		  position: relative;
		}
		.active{
		  color:$brand-color;
		  border-bottom: 4px solid $brand-color;
		}
	  }
	  .city-container{
		padding:0 32px;
		height: calc(720px - 90px);
		overflow-y: scroll;
		font-size: 28px;
		li{
		  line-height: 76px;
		}
		li.on{
		  color: $brand-color
		}
	  }
	  .close{
		position: absolute;
		top: 0;
		right: 0;
		width: 90px;
		height: 90px;background-size:45%;
	  }
	}
  }
</style>
